import React from "react";
import { ChevronDown, ChevronRight, ShieldCheck, MapPin } from "lucide-react";
import { cn } from "@/lib/utils";

function RoleChip({ role }) {
  const isAdmin = role === "admin";
  const isIbo = role === "ibo";
  const cls = isAdmin
    ? "bg-purple-100 text-purple-700"
    : isIbo
    ? "bg-emerald-100 text-emerald-700"
    : "bg-muted text-muted-foreground";
  return (
    <span className={`inline-block text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded ${cls}`}>
      {isAdmin ? <ShieldCheck className="w-2.5 h-2.5 inline mr-0.5 -mt-0.5" /> : null}
      {role}
    </span>
  );
}

function ToggleIcon({ hasChildren, open }) {
  if (!hasChildren) return <span className="inline-block w-4 h-4" />;
  if (open) return <ChevronDown className="w-4 h-4" />;
  return <ChevronRight className="w-4 h-4" />;
}

// Non-recursive shell — renders ONE node's own card content.
// The parent GenealogyTree manages the recursion via an index array.
export default function TreeNodeCard({ node, depth, isRoot, open, onToggle }) {
  const children = node.children || [];
  const hasChildren = children.length > 0;
  const cardCls = cn(
    "flex items-start gap-2 py-2 px-3 rounded-md border bg-white hover:bg-muted/40 transition-colors",
    isRoot ? "border-primary/30 bg-primary/5" : "",
  );
  return (
    <div className={cardCls}>
      <button
        type="button"
        onClick={onToggle}
        disabled={!hasChildren}
        className="mt-0.5 text-muted-foreground hover:text-foreground disabled:opacity-30"
        data-testid={`tree-toggle-${node.id}`}
      >
        <ToggleIcon hasChildren={hasChildren} open={open} />
      </button>
      <div className="flex-1 min-w-0">
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <span className="font-medium truncate">{node.name || "—"}</span>
          {(node.roles || []).map((r) => <RoleChip key={r} role={r} />)}
          {node.city ? (
            <span className="text-xs text-muted-foreground inline-flex items-center gap-0.5">
              <MapPin className="w-3 h-3" /> {node.city}
              {node.state ? `, ${node.state}` : ""}
            </span>
          ) : null}
        </div>
        <div className="text-[11px] text-muted-foreground mt-0.5 flex flex-wrap gap-x-3 gap-y-0.5">
          <span>Team size: <b>{node.team_size}</b></span>
          <span>Own parties: {node.party_count}</span>
          <span>Own bills: {node.bill_count}</span>
          {hasChildren ? <span>Team parties: <b>{node.team_party_count}</b></span> : null}
          {hasChildren ? <span>Team bills: <b>{node.team_bill_count}</b></span> : null}
        </div>
      </div>
    </div>
  );
}
